import React from "react";

import { FeedbackRow } from "./FeedbackRow";
import { InterjectedRow, InterjectedRowType, TableInterjections } from "./InterjectedRow.model";
import { PromoRow } from "./PromoRow";
import { RecommendUsRow } from "./RecommendUsRow";

export interface TableInterjectedRowProps {
  row: InterjectedRow;
  onDismiss: TableInterjections["onDismiss"];
  onFeedbackSubmit?: TableInterjections["onFeedbackSubmit"];
}

/**
 * Picks the component for a row's type.
 *
 * The switch is exhaustive over InterjectedRowType - a new variant that isn't handled here fails
 * to compile on the `never` default rather than silently rendering nothing.
 */
export const TableInterjectedRow = ({ row, onDismiss, onFeedbackSubmit }: TableInterjectedRowProps) => {
  const dismiss = () => onDismiss(row.id);

  switch (row.type) {
    case InterjectedRowType.PROMO:
      return (
        <PromoRow
          row={row}
          onDismiss={dismiss}
        />
      );

    case InterjectedRowType.RECOMMEND_US:
      return (
        <RecommendUsRow
          row={row}
          onDismiss={dismiss}
        />
      );

    case InterjectedRowType.FEEDBACK:
      return (
        <FeedbackRow
          row={row}
          onDismiss={dismiss}
          onSubmit={onFeedbackSubmit && ((value) => onFeedbackSubmit(row, value))}
        />
      );

    default: {
      const unhandled: never = row;
      return unhandled;
    }
  }
};
